import React, { useEffect, useState } from 'react';
import { Modal, ModalProps } from 'react-bootstrap';
import { MdPreview } from 'react-icons/md';
import { CiEdit } from 'react-icons/ci';
type IProps = {
  modalTitle?: string;
  children?: React.ReactNode;
  showView?: boolean;
  showEdit?: boolean;
  modalOff?: boolean;
  size?: ModalProps['size'];

  handleCloseFun?: () => void;
};
const CommonModal = ({
  modalTitle,
  children,
  showEdit,
  showView,
  size,
  modalOff,
  handleCloseFun,
}: IProps) => {
  // modal
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    handleCloseFun?.();
  };
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (modalOff) {
      setShow(false);
    }

    if (!modalOff) {
      setShow(true);
    }
  }, [modalOff]);
  return (
    <div>
      <span
        className='cursor-pointer'
        style={{ cursor: 'pointer' }}
        onClick={() => handleShow()}
      >
        {showView && <MdPreview size={24} />}
        {showEdit && <CiEdit size={24} />}
      </span>
      <Modal size={size} show={show} onHide={handleClose} centered>
        <Modal.Header closeButton style={{ padding: '8px 18px' }}>
          <Modal.Title style={{ color: '#rgb(45 68 91)' }}>
            {modalTitle || ''}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        {/* <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default CommonModal;

// const CommonModal = ({
//   modalTitle,
//   children,
//   showEdit,
//   showView,
//   size,
//   modalOff,
// }: IProps) => {
//   const [show, setShow] = useState(false);

//   useEffect(() => {
//     if (modalOff !== undefined) {
//       setShow(!modalOff);
//     }
//   }, [modalOff]);

//   const handleShow = () => {
//     if (modalOff === undefined) {
//       setShow(true);
//     }
//   };

//   const handleClose = () => {
//     if (modalOff === undefined) {
//       setShow(false);
//     }
//   };

//   return (
//     <div>
//       <span
//         className='cursor-pointer'
//         style={{ cursor: 'pointer' }}
//         onClick={handleShow}
//       >
//         {showView && <MdPreview size={24} />}
//         {showEdit && <CiEdit size={24} />}
//       </span>
//       <Modal size={size} show={show} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{modalTitle || ''}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>{children}</Modal.Body>
//         <Modal.Footer>
//           <Button variant='secondary' onClick={handleClose}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default CommonModal;
